import { CircularProgress, InputAdornment, TextField } from '@mui/material';
import { getFieldLabel } from '../../utils';
import { useTranslation } from 'react-i18next';
import { FormFieldProps } from '.';
import { useRecoilValue } from 'recoil';
import { isCalculationsLoading } from 'state/formState';
import { FieldHelperText } from './FieldHelperText';

interface endAdornmentProps {
  unit?: string;
}

function EndAdornment({ unit }: endAdornmentProps) {
  const isCalculationLoading = useRecoilValue(isCalculationsLoading);

  if (isCalculationLoading) {
    return (
      <InputAdornment position="end">
        <CircularProgress size={20} />
      </InputAdornment>
    );
  }
  if (unit) return <InputAdornment position="end">{unit}</InputAdornment>;
  return null;
}

export default function CalculatedField({
  field,
  error,
  name,
  sx,
  value,
  isImported,
  helperText,
}: FormFieldProps): JSX.Element {
  const { t } = useTranslation();
  const { unit, description } = field.fieldAttributes ?? {};

  return (
    <>
      <TextField
        disabled
        sx={{
          '& .MuiInputBase-root': {
            background: isImported ? theme => theme.palette.grey[200] : null,
          },
          ...sx,
        }}
        fullWidth
        label={getFieldLabel({ field, t })}
        type="text"
        error={error}
        value={value}
        name={name}
        InputProps={{
          endAdornment: EndAdornment({ unit }),
          readOnly: true,
        }}
        InputLabelProps={{ shrink: true }}
        helperText={<FieldHelperText
          description={description}
          helperText={helperText}
          error={error}
        />}
      />
    </>
  );
}
